module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("Introduction: The Work of Interviews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/intro#au"
    }
  }, [_vm._v("• "), _c('i', [_vm._v("CAROL MAGEE AND JOANNA GRABSKI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01"
    }
  }, [_vm._v("1.  Talking to People about Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/chap01#au"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("PATRICK MCNAUGHTON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.  Ghostly Stories: Interviews with Artists in Dakar and the Productive Space around Absence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap02#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("JOANNA GRABSKI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  Can the Artist Speak?: Hamid Kachmar's "), _c('span', {
    staticClass: "strike"
  }, [_vm._v("Subversive")]), _vm._v(" Redemptive Art of Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap03#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("JOSEPH JORDAN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Photography, Narrative Interventions, and (Cross) Cultural Representations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap04#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("CAROL MAGEE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Narrating the Artist: Seyni Camara and the Multiple Constructions of the Artistic Persona")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap05#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("SILVIA FORNI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  Interview: Akinbode Akinbiyi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap06#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("AKINBODE AKINBIYI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  Interweaving Narratives of Art and Activism: Sandra Kriel's Heroic Women")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap07#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("KIM MILLER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  Politics of Narrative at the African Burial Ground in New York City: The Final Monument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap08#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("ANDREA E. FROHNE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Who Owns the Past?: Constructing an Art History of a Malian Masquerade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap09#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("MARY JO ARNOLDI")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.  Framing Practices: Artists’ Voices and the Power of Self-Representation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("CHRISTINE MULLEN KREAMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.  Undisciplined Knowledge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11#au",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("•"), _c('i', [_vm._v("ALLAN DESOUZA AND ALLYSON PURPURA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/back01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX: INTERLOCUTORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/back02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTRIBUTORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 72
// module chunks = 0